export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.error('errorHandler', error, info);
  };
  nuxtApp.hook('vue:error', (error, instance, info) => {
    console.error('vue:error', error, info);
  });
});
